import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  compareAnalyticsDrift,
  fetchAnalyticsDriftGrouped,
  ignoreBeacon,
} from '../../services/locatorDriftService';
import { loadDriftIgnoreListAsync } from './locatorCoreSlice';
import { errorMessage } from './locatorDriftUtils';

export const fetchAnalyticsDriftGroupedAsync = createAsyncThunk(
  'locatorDrift/analytics/fetchGrouped',
  async (_, { rejectWithValue }) => {
    try {
      return await fetchAnalyticsDriftGrouped();
    } catch (error) {
      return rejectWithValue(errorMessage(error));
    }
  },
);

export const compareAnalyticsDriftAsync = createAsyncThunk(
  'locatorDrift/analytics/compare',
  async (payload, { rejectWithValue }) => {
    try {
      return await compareAnalyticsDrift(payload);
    } catch (error) {
      return rejectWithValue(errorMessage(error));
    }
  },
);

export const addIgnoredBeaconAsync = createAsyncThunk(
  'locatorDrift/analytics/addIgnoredBeacon',
  async (beaconId, { dispatch, rejectWithValue }) => {
    try {
      await ignoreBeacon(beaconId);
      await dispatch(loadDriftIgnoreListAsync());
      return beaconId;
    } catch (error) {
      return rejectWithValue(errorMessage(error));
    }
  },
);

const analyticsDriftSlice = createSlice({
  name: 'analyticsDrift',
  initialState: {
    grouped: [],
    groupedLoading: false,
    groupedError: null,
    comparison: null,
    comparing: false,
    error: null,
    showIgnored: false,
  },
  reducers: {
    setAnalyticsDriftShowIgnored(state, action) {
      state.showIgnored = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalyticsDriftGroupedAsync.pending, (state) => {
        state.groupedLoading = true;
        state.groupedError = null;
      })
      .addCase(fetchAnalyticsDriftGroupedAsync.fulfilled, (state, action) => {
        state.groupedLoading = false;
        state.grouped = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchAnalyticsDriftGroupedAsync.rejected, (state, action) => {
        state.groupedLoading = false;
        state.groupedError = action.payload;
      })
      .addCase(compareAnalyticsDriftAsync.pending, (state) => {
        state.comparing = true;
        state.error = null;
      })
      .addCase(compareAnalyticsDriftAsync.fulfilled, (state, action) => {
        state.comparing = false;
        state.comparison = action.payload;
      })
      .addCase(compareAnalyticsDriftAsync.rejected, (state, action) => {
        state.comparing = false;
        state.error = action.payload;
      });
  },
});

export const { setAnalyticsDriftShowIgnored } = analyticsDriftSlice.actions;
export default analyticsDriftSlice.reducer;
